"use strict";

// API-клиент Подсказок.

import urls from "../urls";

const $ = window.jQuery;
const settings = window.DA.settings;

var ENRICHABLE_FIELDS = {
    ADDRESS: [
        "result",
        "postal_code",
        "flat_area",
        "square_meter_price",
        "flat_price",
        "timezone",
        "geo_lat",
        "geo_lon",
        "beltway_hit",
        "beltway_distance",
        "qc_geo",
        "qc_complete",
        "qc_house",
        "fias_id",
        "fias_level",
        "kladr_id",
        "okato",
        "oktmo",
        "tax_office",
        "timezone",
        "city_district_with_type",
        "city_area",
        "metro",
        "qc",
    ],
    NAME: ["result", "result_genitive", "result_dative", "result_ablative"],
};

function ajax(url, data, done, resolver) {
    var params = {
        type: "POST",
        url: url,
        headers: {
            Authorization: "Token " + settings.API_KEY,
        },
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify(data),
    };
    $.ajax(params)
        .done(done)
        .fail(function () {
            resolver.reject();
        });
}

function enrich_fields(sug_type, cleaned_obj, suggestion) {
    if (!suggestion) {
        return cleaned_obj;
    }
    var fields = ENRICHABLE_FIELDS[sug_type];
    var source_obj = Object.assign({}, suggestion.data);
    fields.forEach(function (fieldName) {
        source_obj[fieldName] = cleaned_obj[fieldName];
    });
    return source_obj;
}

function get_url(sug_type, method) {
    var base_part;
    var type_part;
    var url;
    if (method === "clean") {
        base_part = urls.api.demoClean.getUrl();
        type_part = sug_type.toLocaleLowerCase();
        url = base_part + "/" + type_part;
    } else {
        base_part = urls.api.demo.getUrl();
        type_part = sug_type === "NAME" ? "fio" : sug_type.toLocaleLowerCase();
        url = base_part + "/" + method + "/" + type_part;
    }
    return url;
}

function pick_first_suggestion(resolver, response) {
    if (typeof response === "string") {
        response = JSON.parse(response);
    }
    var sug = response.suggestions;
    if (!sug || sug.length === 0) {
        resolver.reject();
        return resolver;
    }
    resolver.resolve(response.suggestions[0]);
}

function enrich_suggestion(resolver, response, sug_type, suggestion) {
    try {
        var cleaned_obj = response[0];
        // address: qc === 3 is considered good
        // name: doesn't have qc === 3 at all
        if (cleaned_obj.qc === 0 || cleaned_obj.qc === 3) {
            var enriched = enrich_fields(sug_type, cleaned_obj, suggestion);
            if (cleaned_obj.qc === 3) {
                // невозможно восстановить правильные коды качества
                enriched.qc = null;
                enriched.qc_complete = null;
            }
            resolver.resolve(enriched);
        } else {
            resolver.reject(cleaned_obj);
        }
    } catch (e) {
        resolver.reject();
    }
}

var SuggestionsService = function (suggestions_type) {
    var self = this;
    self.sug_type = suggestions_type.toUpperCase();

    self.findById = function (query) {
        var resolver = $.Deferred();
        ajax(
            get_url(self.sug_type, "findById"),
            { query: query },
            function (response) {
                pick_first_suggestion(resolver, response);
            },
            resolver
        );
        return resolver;
    };

    self.suggest_one = function (query, res_count) {
        var resolver = $.Deferred();
        res_count = res_count || 1;
        if (!(self.sug_type in ENRICHABLE_FIELDS)) {
            resolver.reject();
            return resolver;
        }
        ajax(
            get_url(self.sug_type, "suggest"),
            { query: query, count: res_count },
            function (response) {
                pick_first_suggestion(resolver, response);
            },
            resolver
        );
        return resolver;
    };

    self.enrich = function (query, suggestion) {
        var resolver = $.Deferred();
        if (!(self.sug_type in ENRICHABLE_FIELDS)) {
            suggestion.data.qc = 0;
            //resolver.resolve(suggestion);
            return resolver;
        }
        ajax(
            get_url(self.sug_type, "clean"),
            [query],
            function (response) {
                if (suggestion) {
                    enrich_suggestion(resolver, response, self.sug_type, suggestion);
                } else {
                    resolver.resolve(response[0]);
                }
            },
            resolver
        );
        return resolver;
    };

    return self;
};

export default SuggestionsService;
